<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col md="6" lg="4" xl="3">
          <v-card>
            <v-row dense>
              <v-col><v-text-field label="Totale merce" hide-details outlined dense reverse readonly :value="euro(totale.totaleMerce)"></v-text-field></v-col>
              <v-col><v-text-field label="Sconto" hide-details outlined dense prefix="€" reverse :readonly="readOnly" :value="scontoFattura" @change="changeScontoFattura"></v-text-field></v-col>
              <v-col><v-text-field label="Netto merce" hide-details outlined dense reverse readonly :value="euro(totale.nettoMerce)"></v-text-field></v-col>
            </v-row>  
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">IVA</th>
                    <th class="text-right">MERCE</th>
                    <th class="text-right">SPESE</th>
                    <th class="text-right">IMPONIBILE</th>
                    <th class="text-right">IMPOSTA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dettaglioIva" :key="index">
                    <!-- <td class="text-left">{{ `${item.aliquota}${isNaN(item.aliquota) ? '' : '%'}` }}</td> -->
                    <td class="text-left">{{ `${item.ivaCodice}${isNaN(item.ivaCodice) ? '' : '%'}` }}</td>
                    <td class="text-right">{{ item.merce | euro }}</td>
                    <td class="text-right">{{ item.spese | euro }}</td>
                    <td class="text-right">{{ item.imponibile | euro }}</td>
                    <td class="text-right">{{ item.iva | euro }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-left">Totale</th>
                    <th class="text-right">{{ totale.nettoMerce | euro }}</th>
                    <th class="text-right">{{ totale.spese | euro }}</th>
                    <th class="text-right">{{ totale.imponibile | euro }}</th>
                    <th class="text-right">{{ totale.iva | euro }}</th>
                  </tr>
                </tfoot>                  
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col md="6" lg="4" xl="3">
          <v-card v-if="pagamentoVisibile" class="mb-3">
            <v-row dense>
              <v-col><v-text-field label="Modalità di pagamento" class="text-caption" hide-details outlined dense readonly :value="modalitaPagamentoDesc"></v-text-field></v-col>              
              <v-col><v-text-field label="Condizioni di pagamento" class="text-caption" hide-details outlined dense readonly :value="condizioniPagamentoDesc"></v-text-field></v-col>
            </v-row>
            <v-row dense v-if="infoBanca">
              <v-col><v-text-field label="Banca" class="text-caption" hide-details :readonly="readOnly" outlined dense :value="infoBanca.descrizione"></v-text-field></v-col>
              <v-col><v-text-field label="IBAN" class="text-caption" hide-details outlined dense readonly :value="infoBanca.IBAN"></v-text-field></v-col>
            </v-row>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>SCADENZE PAGAMENTI</th>
                  </tr>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-right">DATA</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in scadenzePagamenti" :key="index">
                    <td class="text-left">Rata {{index + 1}}</td>
                    <td class="text-right">{{ item.data }}</td>
                    <td class="text-right">{{ item.importo | euro }}</td>
                  </tr>
                </tbody>              
              </template>
            </v-simple-table>
          </v-card>
          <v-card class="pt-2" v-if="spedizioneVisibile">
            <div class="text-caption font-weight-regular pl-3">SPEDIZIONE E TRASPORTO</div>
            <v-row dense class="mt-2">
              <v-col cols="6"><v-select :items="spedizioni" :disabled="readOnly" outlined dense hide-details label="Spedizione" :value="tipoSpedizione" @change="changeSpedizione"></v-select></v-col>
              <v-col cols="6"><v-select :items="consegne" :disabled="readOnly" outlined dense hide-details label="Consegna" :value="consegna" @change="changeConsegna"></v-select></v-col>
              <v-col cols="6"><v-text-field label="Numero colli" type="number" hide-details :disabled="readOnly" outlined dense :value="numeroColli" @change="changeNumeroColli"></v-text-field></v-col>
              <!-- :rules="rulesValidationRequired" -->
              <v-col cols="6"><v-select :items="causali" outlined :disabled="readOnly" dense hide-details label="Causale trasporto" :value="causale" @change="changeCausale"></v-select></v-col>
              <v-col cols="12"><v-select :items="aspettoBeni" :disabled="readOnly" outlined dense hide-details label="Aspetto esteriore dei beni" :value="aspetto" @change="changeAspetto"></v-select></v-col>
              <v-col cols="6"><v-text-field label="Data ritiro" type="date" hide-details :disabled="readOnly" outlined dense :value="dataRitiro" @change="changeDataRitiro"></v-text-field></v-col>
              <v-col cols="6"><v-text-field label="Ora ritiro" type="time" hide-details :disabled="readOnly" outlined dense :value="oraRitiro" @change="changeOraRitiro"></v-text-field></v-col>
            </v-row>          
          </v-card>
        </v-col>
        <v-col md="6" lg="4" xl="3">
          <v-select class="mb-1" :items="esigibilita" :disabled="readOnly" outlined dense hide-details label="Esigibilità Iva" :value="esigibilitaIva" item-value="codice" item-text="descrizione" return-object @change="changeEsigibilita"></v-select>
          <v-card>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>RIEPILOGO SPESE</th>
                  </tr>
                  <tr>
                    <th class="text-left">DESCRIZIONE</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in arrSpeseFattura" :key="item.descrizione">
                    <td class="text-left" :title="tooltipDescrizione(item)">{{ `${item.descrizione} (${item.documentate ? 'd' : 'nd'})` }}</td>
                    <td class="text-right pb-1 pt-1"><v-text-field :disabled="readOnly" :background-color="item.documentate ? 'amber lighten-4' : ''" type="number" reverse hide-details outlined dense prefix="€" v-model="inputSpesa[item.codice]" @change="changeSpesa(index, item)"></v-text-field></td>
                  </tr>
                </tbody>       
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-row dense>
              <v-col>
                <v-textarea label="Annotazioni" class="text-caption" :disabled="readOnly" hide-details outlined dense :value="note" @change="changeNote"></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-simple-table dense class="mt-0">
                  <template v-slot:default>
                    <tbody>
                      <tr><td>TOTALE QUANTITA'</td><td class="text-right">{{ totale.quantita }}</td></tr>
                      <tr><td>TOTALE IMPONIBILE</td><td class="text-right">{{ totale.imponibile | euro }}</td></tr>
                      <tr><td>IVA</td><td class="text-right">{{ totale.iva | euro }}</td></tr>
                      <tr><td>SPESE DOCUMENTATE</td><td class="text-right">{{ totale.speseDocumentate | euro }}</td></tr>
                      <tr><td>TOTALE DOCUMENTO</td><td class="text-right text-h5 blue-grey lighten-4">{{ splitPayment ? totale.imponibile : totale.importo | euro }}</td></tr>
                    </tbody>                    
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>    
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import moment from 'moment'
import { validazioni } from '@/mixins/validazioni.js'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import documenti from './documenti.js'

export default {
  components: {
  },
  mixins: [
    validazioni
  ],  
  props: {
    locDocumento: Object,
    trigger: Number,
    readOnly: { type: Boolean, default: false }
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1,
    repartiFiscali: null,
    modalitaPagamento: null,
    condizioniPagamento: null,
    speseFattura: null,
    banche: null,
    modalitaSelezionata: null,
    codizioniSelezionate: null,
    bancaAppoggio: null,
    spedizioni: [],
    consegne: [],
    causali: [],
    aspettoBeni: [],
    triggerLocale: 1,
    inputSpesa: {},
    esigibilita: []
  }),
  async mounted() {
    const parametriSpedizione = await configurazioni.getConfigurazione('spedizioni')
    this.spedizioni = parametriSpedizione.spedizioni
    this.consegne = parametriSpedizione.consegne
    this.causali = parametriSpedizione.causali
    this.aspettoBeni = parametriSpedizione.aspettoBeni

    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    let repartiFiscali = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
    const aliquote = await configurazioni.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
    repartiFiscali = repartiFiscali.map(x => {
      const iva = aliquote.find(al => al.codice === x.codiceIva)
      if (iva) {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: 'Iva: ' + iva.descrizione,
          aliquota: iva.aliquota
        }
      } else {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: 'Iva: non definita',
          aliquota: 0
        }
      }
    })
    this.repartiFiscali = _.uniqBy(repartiFiscali, 'repartoFiscale')
    const doc_pagamenti = await configurazioni.getConfigurazione('documenti_pagamento')
    this.modalitaPagamento = doc_pagamenti.modalitaPagamento
    this.condizioniPagamento = doc_pagamenti.condizioniPagamento
    this.speseFattura = doc_pagamenti.spese
    this.banche = doc_pagamenti.banche

    const doc_impostazioni = await configurazioni.getConfigurazione('documenti_impostazioni')
    this.esigibilita = doc_impostazioni.esigibilitaIva

    await this.calcolaDatiFooter()
  },
  watch: {
    async trigger() {
      if (!this.modalitaPagamento) return
      await this.calcolaDatiFooter()
    },
    updateTrigger() {
      this.$emit('daSalvare')
    }
  },
  computed: {
    splitPayment() {
      return this.trigger && this.locDocumento.tipoDocumento && this.locDocumento.tipoDocumento.esigibilitaIva && this.locDocumento.tipoDocumento.esigibilitaIva.codice === 'S'
    },
    totale() {
      if (this.trigger && this.triggerLocale && this.locDocumento && this.locDocumento.totali) {
        const totale = this.locDocumento.totali
        return totale.generale
      } else {
        return {}
      }
    },
    dettaglioIva() {
      if (this.trigger && this.triggerLocale && this.locDocumento) {
        const totali = _.omit(this.locDocumento.totali, 'generale')   
        const ive = Object.values(totali)
        return ive
      } else {
        return {}
      }
    },
    scadenzePagamenti() {
      if (this.trigger && this.triggerLocale && this.locDocumento) {
        return this.locDocumento.scadenze && this.locDocumento.scadenze.filter(x => x.importo)
      } else {
        return []
      }
    },
    arrSpeseFattura() {
      if (this.trigger && this.locDocumento) {
        return this.locDocumento.spese
      } else {
        return []
      }
    },
    pagamento() {
     if (this.trigger && this.modalitaSelezionata) {
        return this.modalitaSelezionata
      } else {
        return {}
      }
    },
    modalitaPagamentoDesc() {
      return  _.get(this.modalitaSelezionata, 'descrizione', '')
    },
    condizioniPagamentoDesc() {
      return  _.get(this.codizioniSelezionate, 'descrizione', '')
    },
    infoBanca() {
      return this.bancaAppoggio
    },
    pagamentoVisibile() {
      return this.trigger && _.get(this.locDocumento, 'appoggio.pagamentoVisibile', false)
    },
    note() {
      if (this.locDocumento) {
        return this.locDocumento.note
      } else {
        return ''
      }
    },
    esigibilitaIva() {
      return this.trigger && this.locDocumento && this.locDocumento.tipoDocumento && this.locDocumento.tipoDocumento.esigibilitaIva
    },
    tipoSpedizione() {
      return this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.tipoSpedizione
    },
    consegna() {
      return this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.consegna
    },
    numeroColli() {
      return this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.numeroColli
    },
    causale() {
      return this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.causale
    },
    aspetto() {
      return this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.aspetto
    },
    spedizioneVisibile() {
      return this.trigger && this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.spedizioneVisibile
    },
    dataRitiro() {
      return this.trigger && (_.get(this.locDocumento, 'spedizione.dataRitiro', '') ? moment(_.get(this.locDocumento, 'spedizione.dataRitiro', '')).format('YYYY-MM-DD') : '') // (this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.dataRitiro) // || moment().format('DD/MM/YYYY')
    },
    oraRitiro() {
      return (this.locDocumento && this.locDocumento.spedizione && this.locDocumento.spedizione.oraRitiro) // || moment().format('HH:mm')
    },
    scontoFattura() {
      return this.locDocumento && this.locDocumento.scontoFattura
    },
    rulesValidationRequired() {
      let rl = []
      rl.push(this.rules.required)
      return rl
    }      
  },
  methods: {
    datiCompleti() {
      const valid = this.$refs.form.validate()
      return valid // TODO: Completare verifica
    },
    tooltipDescrizione(item) {
      if (item.documentate) {
        return `Le spese documentate risultano da un altro "documento", ovvero un'altra fattura e pertanto sono comprensive di IVA`
      } else {
        return `Le spese non documentate non comprendovo l'iva e sono ripartite proporzionalmente sulle varie aliquote`
      }
    },
    async calcolaDatiFooter() {
      var totali = {}
      const clifor = _.get(this.locDocumento, 'appoggio.clifor', null)
      if (!clifor || this.locDocumento.righe.length === 0) return
      const mp = _.get(this.locDocumento, 'pagamento.dettaglio.modalita') || _.get(this.locDocumento, 'pagamento.modalita.codice')
      var banca, modalitaPagamento
      if (mp) {
        modalitaPagamento = this.modalitaPagamento.find(x => x.codice === mp)
        this.modalitaSelezionata = modalitaPagamento
        banca = modalitaPagamento.infoBanca ? this.banche.find(x => x.codice === modalitaPagamento.infoBanca)  : null

        this.bancaAppoggio = banca
        this.locDocumento.pagamento.infoBanca = banca
        this.locDocumento.pagamento.codiceXml = modalitaPagamento.codiceXml
      }
      const cd = this.locDocumento.pagamento.condizioni
      const condizioniPagamento = this.condizioniPagamento.find(x => x.codice === cd)
      this.codizioniSelezionate = condizioniPagamento

      this.locDocumento.tipoDocumento.esigibilitaIva = this.locDocumento.tipoDocumento.esigibilitaIva || _.get(this.locDocumento, 'anagrafica.cliente.amministrativi.esigibilitaIva')
      
      const speseFattura = this.locDocumento.spese || clifor.fatturazione.spese || this.speseFattura || []
      let valori = documenti.calcolaValoriDocumento(this.locDocumento, this.repartiFiscali)
      if (valori.length === 0) return
      const scontoInFattura = this.locDocumento.scontoFattura || 0
      
      const totImpo = _.sumBy(valori, (el) => { return el.importoNettoTotale })
      const totaleMerce = totImpo - scontoInFattura // Si parte dalla somma dei prodotti meno lo sconto in fattura
      const { spese, totaleSpese } = documenti.calcolaSpese(speseFattura, totaleMerce)
      for (let s of spese) {
        this.inputSpesa = this.inputSpesa || {}
        this.inputSpesa[s.codice] = s.valore
      }

      totali = documenti.calcolaTotaliAliquote_v2(totali, valori, spese, scontoInFattura, totaleMerce)
      // const totaleCompleti = documenti.calcolaTotaliAliquoteSpese(totali, speseFattura, scontoInFattura)
      // const totaleCompleti = documenti.calcolaTotaliAliquoteSpese(totali, spese.filter(x => !x.documentate), totaleMerce)
      const totaleCompleti = totali
      const scadenze = documenti.calcolaScadenze(totaleCompleti, modalitaPagamento, this.splitPayment)

      // const { spese, totaleSpese } = documenti.calcolaSpese(speseFattura, totaleCompleti.generale.imponibile, totaleCompleti.generale.imponibile)
      this.locDocumento.totali = totaleCompleti
      this.locDocumento.scadenze = scadenze
      if (scadenze.length > 1) {
        this.locDocumento.pagamento.condizioni = 'TP01'
      }
      this.locDocumento.spese = spese

      if (this.spedizioneVisibile) {
        if (!this.dataRitiro) {
          this.locDocumento.spedizione.dataRitiro = moment().format('YYYY-MM-DD') // .format('DD/MM/YYYY')
          this.locDocumento.spedizione.oraRitiro = moment().format('HH:mm')
        }
      }
      await this.$nextTick()
      this.$emit('updateTotali')
    },
    euro(value) {
      return this.$options.filters.euro(value)
    },
    changeNote(value) {
      this.componentValueChange({ model: 'note', subModel: null, value })
    },
    async changeScontoFattura(value){
      this.componentValueChange({ model: 'scontoFattura', subModel: null, value })
      await this.$nextTick()
      this.calcolaDatiFooter()
      await this.$nextTick()
      this.triggerLocale++
    },
    async changeEsigibilita(value) {
      this.componentValueChange({ model: 'tipoDocumento.esigibilitaIva', subModel: null, value })
      await this.$nextTick()
      this.calcolaDatiFooter()
      await this.$nextTick()
      this.triggerLocale++
    },
    changeSpedizione(value) {
      this.componentValueChange({ model: 'spedizione.tipoSpedizione', subModel: null, value })
    },
    changeConsegna(value) {
      this.componentValueChange({ model: 'spedizione.consegna', subModel: null, value })
    },
    changeNumeroColli(value) {
      this.componentValueChange({ model: 'spedizione.numeroColli', subModel: null, value })
    },
    changeCausale(value) {
      this.componentValueChange({ model: 'spedizione.causale', subModel: null, value })
    },
    changeAspetto(value) {
      this.componentValueChange({ model: 'spedizione.aspetto', subModel: null, value })
    },
    changeDataRitiro(value) {
      this.componentValueChange({ model: 'spedizione.dataRitiro', subModel: null, value })
    },  
    changeOraRitiro(value) {
      this.componentValueChange({ model: 'spedizione.oraRitiro', subModel: null, value })
    },
    async changeSpesa(index, item) {
      const value = parseFloat(this.inputSpesa[item.codice])
      let spesa = this.locDocumento.spese.find(x => x.codice === item.codice)
      spesa.valore = value
      await this.$nextTick()
      this.calcolaDatiFooter()
      await this.$nextTick()
      this.triggerLocale++
      this.updateTrigger++
    }, 
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      switch (data.model) {
         case 'tipoDocumento.codice':
          this.locDocumento.appoggio.tipoDocumento = data.value
          this.locDocumento.appoggio.clienteVisibile = data.value.visualizzaCliente
          this.locDocumento.appoggio.fornitoreVisibile = data.value.visualizzaFornitore
          this.locDocumento.appoggio.spedizioneVisibile = data.value.infoSpedizione
          this.locDocumento.appoggio.pagamentoVisibile = data.value.infoPagamento
          this.locDocumento.tipoDocumento = data.value
          // this.locDocumento.tipoDocumentoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locDocumento.appoggio.clifor = clifor
           _.set(this.locDocumento,'appoggio.clifor', clifor)
          _.set(this.locDocumento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
           _.set(this.locDocumento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
           if (!_.get(this.locDocumento, 'spedizione.destinazione')) {
            const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
            _.set(this.locDocumento, 'spedizione.destinazione', sede)
           }
           _.set(this.locDocumento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
           _.set(this.locDocumento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))
           await this.$nextTick()
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locDocumento, 'spedizione.destinazione', data.value)
          this.updateTrigger++
          break;
        default:
          this.updateTrigger++
          break
      } 
    }
  }
}

</script>
